import React, {
  useCallback, useEffect, useState,
} from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../api/req';

import IconAlert from '../../../components/blanks/common/IconAlert';
import { Loader } from '../../../components/bootStrap';

function downloadFile(content, type, filename) {
  const byteNumbers = new Array(content.length);
  for (let i = 0; i < content.length; i += 1) {
    byteNumbers[i] = content.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type });
  const URL = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = URL;
  a.download = filename;
  document.body.append(a);
  a.click();
}

function Editor() {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  // const [Result, setResult] = useState(null);

  const { uid } = useParams();

  const onLoadStart = useCallback(() => {
    setLoading(true);
    setErr(null);
  }, []);

  const onLoadEnd = useCallback(() => {
    setLoading(false);
  }, []);
  const onError = useCallback((e) => setErr(e), []);

  const load = useCallback(
    async () => {
      const r = await api.get(`/api/akt_dvk/qr/${uid}/`, () => null);
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      return r.json();
    },
    [uid],
  );

  const reload = useCallback(() => {
    onLoadStart();
    load()
      .then((rData) => {
        // setResult(rData);
        downloadFile(atob(rData.result), rData.type, rData.filename);
      })
      .catch((e) => onError(e.message))
      .finally(() => onLoadEnd());
  }, [load, onError, onLoadEnd, onLoadStart]);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <>
      {loading && (<Loader />)}
      {err && (
        <IconAlert dismissible variant="danger" onClose={() => setErr(null)}>
          {err}
        </IconAlert>
      )}
    </>
  );
}

export default Editor;

// import Editor from './editor';
//
// const ReadQR = {
//   Editor,
// };
//
// export default ReadQR;
